module.exports = __webpack_public_path__ + "static/media/arrow-right-diagonal.8e70683f.svg";